import { getOrRefreshFirebaseToken } from "../config/getFirebaseToken";
import addLogDocument from "./addLogDocument.js";
import { auth, dbCentral } from "../config/FirebaseConfig.js";
import { getDoc, doc } from "firebase/firestore";

export default async function removeCarnet(carnetId, prefix) {
  const token = await getOrRefreshFirebaseToken();
  const url = `${prefix}carnets/${carnetId}`;

  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };

  try {
    const start = new Date();
    const response = await fetch(url, {
      method: "DELETE",
      headers,
    });

    const currentUser = auth.currentUser;

    if (!currentUser) {
      return "User not logged in";
    }

    const userRef = doc(dbCentral, "user", currentUser.uid);
    const userSnapshot = await getDoc(userRef);
    const responseText = await response.text();
    const end = new Date();
    const elapsed = end - start;

    if (userSnapshot.exists()) {
      const orgId = userSnapshot.get("org_id");

      await addLogDocument(
        url,
        prefix,
        userRef.id,
        orgId,
        response.status.toString(),
        "",
        carnetId,
        "",
        responseText,
        "DELETE",
        elapsed
      );
    }

    if (response.ok) {
      return JSON.parse(responseText);
    } else {
      console.error(`Failed to delete carnet: ${response.status}`);
      return "";
    }
  } catch (error) {
    console.error(`Exception occurred: ${error.message}`);
    return "";
  }
}